export const apiConfig = {
  baseUrl: 'https://api.fapshi.com',
  eventUrl: '/event',
  eventTransUrl: '/event-trans',
  createEventUrl: '/new-event',
  donationUrl: '/donationTrans',
  imageUploadUrl: 'https://api.fapshi.com/imageUpload'
};
